import $ from 'jquery';
import 'slick-carousel';

$(function() {

  var $imageSlider = $('.image-slider');

  $imageSlider.each(function(element, index) {
    var $this = $(this),
        $parent = $this.parent(),
        $caption = $parent.find('.image-slider-caption');

    if($caption.length > 0) {
      $caption.slick({
        asNavFor: $this,
        fade: true,
        dots: false,
        arrows: false,
        cssEase: 'ease-in-out',
        focusOnSelect: false
      });
    }

    if ($caption.length === 0) {
      $caption = false;
    }

    $this.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      fade: false,
      cssEase: 'ease-in-out',
      pauseOnHover: false,
      slickPlay: false,
      swipeToSlide: false,
      autoplay: true,
      autoplaySpeed: 6000,
      focusOnSelect: false,
      asNavFor: $caption
    });

  });

});